import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .make();

schema.prop('moduleId').setType(Number);
schema.prop('podcastId').setType(Number);

export default schema;
